namespace JupitersChoice {
    export class FreeGamePopup extends Sapphire.Sprite {

        @inject('StateModel') _stateModel: Sapphire.StateModel;

        constructor() {
            super();
        }

        construct(data: any) {
            super.construct(data);
        }

        setOrientation(orientation: string): void {
            this.x = this['data'][orientation].x;
            this.y = this['data'][orientation].y;

            if (this._stateModel.currentSubgame === 'FreeGame' && orientation === 'portrait') {
                this.y += 191;
            }
        }
    }
}